export function AppConfig($routeProvider, $qProvider) {
    'ngInject';
    $qProvider.errorOnUnhandledRejections(false);

    function resolveAPI(restaurantService, ToastApiService, accountService) {
        'ngInject';
        return restaurantService.status.then(() => {
            let url = restaurantService.data.restaurantInfo.general.frontendUrl;
            ToastApiService.initialize(url);
            accountService.checkTokens();
        });
    }

    $routeProvider
        .when('/', {
            template: '<container></container>',
            resolve: { resolveAPI }
        })
        .otherwise({
            redirectTo: '/',
            resolve: { resolveAPI }
        });
}
